import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { Observable } from 'rxjs';
import { ILoginModel } from 'app/auth/models/loginModel';
import { ILoginToken } from 'app/shared/models/authtoken';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthService extends ServiceBase {
	constructor(private http: HttpClient) { super(); }
	login(loginModel: ILoginModel): Observable<ILoginToken> {
		const completeUrl: string = this.url + '/connect/token';
		const body = `username=${loginModel.username}&password=${loginModel.password}&grant_type=password`;
		const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
		return this.http.post<ILoginToken>(completeUrl, body, { headers: headers }).pipe(
			catchError(this.handleError));
	}

	resetPassword(email: string, password: string, token: string): Observable<ILoginToken> {
		const completeUrl: string = this.url + '/authorization/ResetPassword';
		// let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
		return this.http.post(completeUrl, { email: email, token: token, password: password }).pipe(
            map((response: ILoginToken) => response),
			catchError(this.handleError),);
	}

	recoverPassword(email: string): Observable<ILoginToken> {
		const completeUrl: string = this.url + '/authorization/RecoverPassword';
		return this.http.post(completeUrl, { email: email }).pipe(
            map((response: ILoginToken) => response),
			catchError(this.handleError),);
	}

	identityErrorsToArray(error): string[] {
		const individuarErrors: string[] = [];
		individuarErrors.push(error.error_description);
		for (const errorType of Object.keys(error).map(key => error[key])) {
			for (const indError of errorType) {
				individuarErrors.push(indError);
			}
		}
		return individuarErrors;
	}
}
